export const GET_CSV_FILE="GET_CSV_FILE"
export const GET_CSV_FILE_SUCCESS="GET_CSV_FILE_SUCCESS"
export const GET_CSV_FILE_FAILED="GET_CSV_FILE_FAILED"
export const IMPORT_MIGRATION_DATA="IMPORT_MIGRATION_DATA"
export const IMPORT_MIGRATION_DATA_SUCCESS="IMPORT_MIGRATION_DATA_SUCCESS"
export const IMPORT_MIGRATION_DATA_FAILED="IMPORT_MIGRATION_DATA_FAILED"
export const FIELD_MAP_DATA="FIELD_MAP_DATA"
export const FIELD_MAP_DATA_SUCCESS="FIELD_MAP_DATA_SUCCESS"
export const FIELD_MAP_DATA_FAILED="FIELD_MAP_DATA_FAILED"
export const BULK_IMPORT_MIGRATION_DATA="BULK_IMPORT_MIGRATION_DATA"
export const BULK_IMPORT_MIGRATION_DATA_SUCCESS="BULK_IMPORT_MIGRATION_DATA_SUCCESS"
export const BULK_IMPORT_MIGRATION_DATA_FAILED="BULK_IMPORT_MIGRATION_DATA_FAILED"
export const GET_MIGRATION_IDS="GET_MIGRATION_IDS"
export const GET_MIGRATION_IDS_SUCCESS="GET_MIGRATION_IDS_SUCCESS"
export const GET_MIGRATION_IDS_FAILED="GET_MIGRATION_IDS_FAILED"
export const GET_MIGRATION_STATUS="GET_MIGRATION_STATUS"
export const GET_MIGRATION_STATUS_SUCCESS="GET_MIGRATION_STATUS_SUCCESS"
export const GET_MIGRATION_STATUS_FAILED="GET_MIGRATION_STATUS_FAILED"
